import { getTypeColor, needsDarkText } from "@/data/types";
import { cn } from "@/lib/utils";

interface DualTypeBadgeProps {
  primaryType: string;
  secondaryType: string;
  className?: string;
  onClick?: () => void;
}

export function DualTypeBadge({
  primaryType,
  secondaryType,
  className,
  onClick,
}: DualTypeBadgeProps) {
  const primaryColor = getTypeColor(primaryType);
  const secondaryColor = getTypeColor(secondaryType);
  const useDarkText = needsDarkText(secondaryColor);

  const baseClasses = cn(
    "inline-block px-2 sm:px-3 py-1 sm:py-1.5 rounded-md font-semibold text-xs sm:text-sm min-w-[70px] sm:min-w-[90px] text-center relative overflow-hidden transition-all duration-300",
    onClick && "cursor-pointer hover:opacity-80",
    className
  );

  return (
    <span
      className={baseClasses}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.();
      }}
      style={{
        background: `linear-gradient(160deg, ${primaryColor} 50%, ${secondaryColor} 50%)`,
        color: useDarkText ? "#1a1a1a" : "#ffffff",
      }}
    >
      {secondaryType}
    </span>
  );
}
